import { render, staticRenderFns } from "./AppInputSearchAdd2.vue?vue&type=template&id=851931dc&scoped=true"
import script from "./AppInputSearchAdd2.vue?vue&type=script&lang=js"
export * from "./AppInputSearchAdd2.vue?vue&type=script&lang=js"
import style0 from "./AppInputSearchAdd2.vue?vue&type=style&index=0&id=851931dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851931dc",
  null
  
)

export default component.exports